"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.profileImageFactory = void 0;
const Factory = require("factory.ts");
exports.profileImageFactory = Factory.Sync.makeFactory({
    image_type: 'original',
    url: 'http://example.com/test.png',
});
